import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import th from './locales/th.json'

const i18n = createI18n({
  legacy: false, // required if you’re using the Composition API
  locale: 'th', // default language
  fallbackLocale: 'en',
  messages: {
    en,
    th,
  },
})

export default i18n
